module.exports = __webpack_public_path__ + "static/media/no-pic-boy.7a430d64.jpg";